// import {
//   FETCH_LOCATIONS_REQUEST,
//   FETCH_LOCATIONS_SUCCESS,
//   FETCH_LOCATIONS_FAILURE,
//   FETCH_EMPLOYEES_BY_LOCATION_REQUEST,
//   FETCH_EMPLOYEES_BY_LOCATION_SUCCESS,
//   FETCH_EMPLOYEES_BY_LOCATION_FAILURE,
//   FETCH_SHIFTS_REQUEST,
//   FETCH_SHIFTS_SUCCESS,
//   FETCH_SHIFTS_FAILURE,
//   POST_ROSTER_REQUEST,
//   POST_ROSTER_SUCCESS,
//   POST_ROSTER_FAILURE,
//   POST_SCHEDULE_REQUEST,
//   POST_SCHEDULE_SUCCESS,
//   POST_SCHEDULE_FAILURE,
//   FETCH_ROSTER_DETAILS_REQUEST,
//   FETCH_ROSTER_DETAILS_SUCCESS,
//   FETCH_ROSTER_DETAILS_FAILURE,
//   FETCH_ALL_ROSTER_DETAILS_REQUEST,
//   FETCH_ALL_ROSTER_DETAILS_SUCCESS,
//   FETCH_ALL_ROSTER_DETAILS_FAILURE,
// } from "../actions/RosterActions";

// const initialState = {
//   // Locations
//   locations: [],
//   loadingLocations: false,
//   errorLocations: null,
  
//   // Employees by location
//   employeesByLocation: {},
//   loadingEmployees: false,
//   errorEmployees: null,
  
//   // Shifts/Schedules
//   shifts: [],
//   loadingShifts: false,
//   errorShifts: null,
  
//   // Roster operations
//   postingRoster: false,
//   postRosterSuccess: false,
//   postRosterError: null,
  
//   // Schedule operations
//   postingSchedule: false,
//   postScheduleSuccess: false,
//   postScheduleError: null,
  
//   // Roster details
//   rosterDetails: [],
//   loadingRosterDetails: false,
//   errorRosterDetails: null,
  
//   // All roster details (filtered)
//   allRosterDetails: [],
//   loadingAllRosterDetails: false,
//   errorAllRosterDetails: null,
  
//   // UI state
//   selectedDates: [],
//   selectedShifts: [],
//   selectedLocation: null,
//   selectedEmployees: [],
// };

// export default function rosterReducer(state = initialState, action) {
//   switch (action.type) {
//     // Locations
//     case FETCH_LOCATIONS_REQUEST:
//       return { ...state, loadingLocations: true, errorLocations: null };
//     case FETCH_LOCATIONS_SUCCESS:
//       return { ...state, loadingLocations: false, locations: action.payload };
//     case FETCH_LOCATIONS_FAILURE:
//       return { ...state, loadingLocations: false, errorLocations: action.payload };
    
//     // Employees by location
//     case FETCH_EMPLOYEES_BY_LOCATION_REQUEST:
//       return { ...state, loadingEmployees: true, errorEmployees: null };
//     case FETCH_EMPLOYEES_BY_LOCATION_SUCCESS:
//       return {
//         ...state,
//         loadingEmployees: false,
//         employeesByLocation: {
//           ...state.employeesByLocation,
//           [action.payload.locationCode]: action.payload.employees,
//         },
//       };
//     case FETCH_EMPLOYEES_BY_LOCATION_FAILURE:
//       return { ...state, loadingEmployees: false, errorEmployees: action.payload };
    
//     // Shifts
//     case FETCH_SHIFTS_REQUEST:
//       return { ...state, loadingShifts: true, errorShifts: null };
//     case FETCH_SHIFTS_SUCCESS:
//       return { ...state, loadingShifts: false, shifts: action.payload };
//     case FETCH_SHIFTS_FAILURE:
//       return { ...state, loadingShifts: false, errorShifts: action.payload };
    
//     // Post roster
//     case POST_ROSTER_REQUEST:
//       return { ...state, postingRoster: true, postRosterSuccess: false, postRosterError: null };
//     case POST_ROSTER_SUCCESS:
//       return { ...state, postingRoster: false, postRosterSuccess: true };
//     case POST_ROSTER_FAILURE:
//       return { ...state, postingRoster: false, postRosterError: action.payload };
    
//     // Post schedule
//     case POST_SCHEDULE_REQUEST:
//       return { ...state, postingSchedule: true, postScheduleSuccess: false, postScheduleError: null };
//     case POST_SCHEDULE_SUCCESS:
//       return { ...state, postingSchedule: false, postScheduleSuccess: true };
//     case POST_SCHEDULE_FAILURE:
//       return { ...state, postingSchedule: false, postScheduleError: action.payload };
    
//     // Roster details
//     case FETCH_ROSTER_DETAILS_REQUEST:
//       return { ...state, loadingRosterDetails: true, errorRosterDetails: null };
//     case FETCH_ROSTER_DETAILS_SUCCESS:
//       return { ...state, loadingRosterDetails: false, rosterDetails: action.payload };
//     case FETCH_ROSTER_DETAILS_FAILURE:
//       return { ...state, loadingRosterDetails: false, errorRosterDetails: action.payload };
    
//     // All roster details
//     case FETCH_ALL_ROSTER_DETAILS_REQUEST:
//       return { ...state, loadingAllRosterDetails: true, errorAllRosterDetails: null };
//     case FETCH_ALL_ROSTER_DETAILS_SUCCESS:
//       return { ...state, loadingAllRosterDetails: false, allRosterDetails: action.payload };
//     case FETCH_ALL_ROSTER_DETAILS_FAILURE:
//       return { ...state, loadingAllRosterDetails: false, errorAllRosterDetails: action.payload };
    
//     // UI state management
//     case "SET_SELECTED_DATES":
//       return { ...state, selectedDates: action.payload };
    
//     case "SET_SELECTED_SHIFTS":
//       return { ...state, selectedShifts: action.payload };
    
//     case "SET_SELECTED_LOCATION":
//       return { ...state, selectedLocation: action.payload };
    
//     case "SET_SELECTED_EMPLOYEES":
//       return { ...state, selectedEmployees: action.payload };
    
//     case "CLEAR_SELECTED_EMPLOYEES":
//       return { ...state, selectedEmployees: [] };
    
//     case "CLEAR_ROSTER_STATE":
//       return {
//         ...initialState,
//         locations: state.locations,
//         shifts: state.shifts,
//         employeesByLocation: state.employeesByLocation,
//       };
    
//     default:
//       return state;
//   }
// }

import * as ActionTypes from "../actions/actionTypes";

const initialState = {
  // Locations
  locations: [],
  loadingLocations: false,
  errorLocations: null,
  
  // Employees by location
  employeesByLocation: {},
  loadingEmployees: false,
  errorEmployees: null,
  
  // Shifts/Schedules
  shifts: [],
  loadingShifts: false,
  errorShifts: null,
  
  // Roster operations
  postingRoster: false,
  postRosterSuccess: false,
  postRosterError: null,
  
  // Schedule operations
  postingSchedule: false,
  postScheduleSuccess: false,
  postScheduleError: null,
  
  // Roster details
  rosterDetails: [],
  loadingRosterDetails: false,
  errorRosterDetails: null,
  
  // All roster details (filtered)
  allRosterDetails: [],
  loadingAllRosterDetails: false,
  errorAllRosterDetails: null,
  
  // UI state
  selectedDates: [],
  selectedShifts: [],
  selectedLocation: null,
  selectedEmployees: [],
};

export default function rosterReducer(state = initialState, action) {
  switch (action.type) {
    // Locations
    case ActionTypes.FETCH_LOCATIONS_REQUEST:
      return { ...state, loadingLocations: true, errorLocations: null };
    case ActionTypes.FETCH_LOCATIONS_SUCCESS:
      return { ...state, loadingLocations: false, locations: action.payload };
    case ActionTypes.FETCH_LOCATIONS_FAILURE:
      return { ...state, loadingLocations: false, errorLocations: action.payload };
    
    // Employees by location
    case ActionTypes.FETCH_EMPLOYEES_BY_LOCATION_REQUEST:
      return { ...state, loadingEmployees: true, errorEmployees: null };
    case ActionTypes.FETCH_EMPLOYEES_BY_LOCATION_SUCCESS:
      return {
        ...state,
        loadingEmployees: false,
        employeesByLocation: {
          ...state.employeesByLocation,
          [action.payload.locationCode]: action.payload.employees,
        },
      };
    case ActionTypes.FETCH_EMPLOYEES_BY_LOCATION_FAILURE:
      return { ...state, loadingEmployees: false, errorEmployees: action.payload };
    
    // Shifts
    case ActionTypes.FETCH_SHIFTS_REQUEST:
      return { ...state, loadingShifts: true, errorShifts: null };
    case ActionTypes.FETCH_SHIFTS_SUCCESS:
      return { ...state, loadingShifts: false, shifts: action.payload };
    case ActionTypes.FETCH_SHIFTS_FAILURE:
      return { ...state, loadingShifts: false, errorShifts: action.payload };
    
    // Post roster
    case ActionTypes.POST_ROSTER_REQUEST:
      return { ...state, postingRoster: true, postRosterSuccess: false, postRosterError: null };
    case ActionTypes.POST_ROSTER_SUCCESS:
      return { ...state, postingRoster: false, postRosterSuccess: true };
    case ActionTypes.POST_ROSTER_FAILURE:
      return { ...state, postingRoster: false, postRosterError: action.payload };
    
    // Post schedule
    case ActionTypes.POST_SCHEDULE_REQUEST:
      return { ...state, postingSchedule: true, postScheduleSuccess: false, postScheduleError: null };
    case ActionTypes.POST_SCHEDULE_SUCCESS:
      return { ...state, postingSchedule: false, postScheduleSuccess: true };
    case ActionTypes.POST_SCHEDULE_FAILURE:
      return { ...state, postingSchedule: false, postScheduleError: action.payload };
    
    // Roster details
    case ActionTypes.FETCH_ROSTER_DETAILS_REQUEST:
      return { ...state, loadingRosterDetails: true, errorRosterDetails: null };
    case ActionTypes.FETCH_ROSTER_DETAILS_SUCCESS:
      return { ...state, loadingRosterDetails: false, rosterDetails: action.payload };
    case ActionTypes.FETCH_ROSTER_DETAILS_FAILURE:
      return { ...state, loadingRosterDetails: false, errorRosterDetails: action.payload };
    
    // All roster details
    case ActionTypes.FETCH_ALL_ROSTER_DETAILS_REQUEST:
      return { ...state, loadingAllRosterDetails: true, errorAllRosterDetails: null };
    case ActionTypes.FETCH_ALL_ROSTER_DETAILS_SUCCESS:
      return { ...state, loadingAllRosterDetails: false, allRosterDetails: action.payload };
    case ActionTypes.FETCH_ALL_ROSTER_DETAILS_FAILURE:
      return { ...state, loadingAllRosterDetails: false, errorAllRosterDetails: action.payload };
    
    // UI state management
    case ActionTypes.SET_SELECTED_DATES:
      return { ...state, selectedDates: action.payload };
    
    case ActionTypes.SET_SELECTED_SHIFTS:
      return { ...state, selectedShifts: action.payload };
    
    case ActionTypes.SET_SELECTED_LOCATION:
      return { ...state, selectedLocation: action.payload };
    
    case ActionTypes.CLEAR_SELECTED_EMPLOYEES:
      return { ...state, selectedEmployees: [] };
    
    case ActionTypes.CLEAR_ROSTER_STATE:
      return {
        ...initialState,
        locations: state.locations,
        shifts: state.shifts,
        employeesByLocation: state.employeesByLocation,
      };
    
    case ActionTypes.RESET_POST_ROSTER_STATE:
      return {
        ...state,
        postingRoster: false,
        postRosterSuccess: false,
        postRosterError: null,
        postingSchedule: false,
        postScheduleSuccess: false,
        postScheduleError: null,
      };
    
    default:
      return state;
  }
}